const tipoProfesionalData = [
    {id:'1', parametro: "Psicopedagoga"},
    {id:'2', parametro: "Lic. en psicopedagogía"},
    {id:'3', parametro: "Fonoaudióloga"},
    {id:'4', parametro: "Lic. en fonoaudiología"},
    {id:'5', parametro: "Lic. en psicología"},
    {id:'6', parametro: "Maestra especial"},
    {id:'7', parametro: "Lic. en ciencias de la educación"},
    {id:'8', parametro: "Docente"},
    {id:'99', parametro: "Otro"}
];

const ocupacionProfesionalData = [
    {id:'1', parametro: "Clínica privada"},
    {id:'2', parametro: "Clínica hospitalaria"},
    {id:'3', parametro: "EOE"},
    {id:'4', parametro: "APND"},
    {id:'5', parametro: "MAI"},
    {id:'6', parametro: "Tutor"},
    {id:'7', parametro: "Profesor particular"}
];

const terapiasActualesData = [
    {id:'1', parametro: "Psicología"},
    {id:'2', parametro: "Psicopedagogía"},
    {id:'3', parametro: "Fonoaudiología"},
    {id:'4', parametro: "Terapia ocupacional"},
    {id:'5', parametro: "Estimulación temprana"},
    {id:'6', parametro: "Musicoterapia"},
    {id:'7', parametro: "Habilidades sociales"},
    {id:'8', parametro: "Tutoría"},
    {id:'9', parametro: "Maestra particular"}
];

const nivelEstudiosData = [
    {id:'1', parametro: "Primario incompleto"},
    {id:'2', parametro: "Primario completo"},
    {id:'3', parametro: "Secundario incompleto"},
    {id:'4', parametro: "Secundario completo"},
    {id:'5', parametro: "Terciario incompleto"},
    {id:'6', parametro: "Terciario completo"},
    {id:'7', parametro: "Universitario incompleto"},
    {id:'8', parametro: "Universitario completo"},
    {id:'9', parametro: "Posgrado incompleto"},
    {id:'10', parametro: "Posgrado completo"},
    {id:'11', parametro: "Maestría incompleto"},
    {id:'12', parametro: "Maestría completo"},
    {id:'13', parametro: "Doctorado incompleto"},
    {id:'14', parametro: "Doctorado completo"}
];

const siNoData = [
    {id:'1', parametro: "Si"},
    {id:'2', parametro: "No"}
]

const generoData = [
    {
        id: '1',
        parametro: 'Femenino'
    },
    {
        id: '2',
        parametro: 'Masculino'
    },
    {
        id: '3',
        parametro: 'Prefiero no decirlo'
    }
];

export {
 tipoProfesionalData,
 ocupacionProfesionalData,
 terapiasActualesData,
 nivelEstudiosData,
 siNoData,
 generoData
}